import 'twin.macro';
import React from 'react';
import { Field, Form } from 'react-final-form';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import { Radios } from '@teetsh/app/src/components/Form/Radios';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { useNavigate } from 'react-router-dom';
import subscriptionUrl from '@teetsh/app/src/containers/UserSettings/Souscription/urls';
import {
  ToolType,
  tools,
} from 'containers/UserSettings/Souscription/Cancel/CancelSteps/tools';
import InputComponent from 'components/Form/InputGroup/formWrapper';
import { useTranslation } from 'react-i18next';
import { useTranslatedValidation } from 'utils/useTranslatedValidation';

export function OtherTool() {
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);
  const { required } = useTranslatedValidation();
  const onClose = () => navigate('/settings/subscription');
  return (
    <Form<{ tool: ToolType; otherToolDetail }>
      initialValues={{}}
      onSubmit={async v => {
        let otherToolDetailQuery = '';
        if (v.tool === 'other') {
          otherToolDetailQuery = `&otherToolDetail=${v.otherToolDetail}`;
        }

        return navigate(
          `${subscriptionUrl.details()}?reason=otherTool2${otherToolDetailQuery}`,
        );
      }}
    >
      {({ handleSubmit, submitting, valid, values }) => (
        <SimpleModal
          isOpen
          closeModalFct={() => onClose()}
          validateTitle={t(
            'userSettings:subscription.cancel.featureWarningModal.continueCancel',
          )}
          disabled={!valid}
          isLoading={submitting}
          validateAction={() => handleSubmit()}
        >
          <div tw="p-8">
            <H2 tw="mb-8">
              {t('userSettings:subscription.cancel.reasons.whichTool')}
            </H2>
            <Field
              name="tool"
              validate={required}
              render={({ input: { value, onChange } }) => (
                <Radios
                  value={value}
                  onChange={v => onChange(v)}
                  options={tools.map(tool => ({
                    label: t(`subscription.cancel.reasons.tools.${tool}`),
                    value: tool,
                  }))}
                />
              )}
            />
            {values?.tool === 'other' && (
              <div tw="mt-2">
                <Field
                  name="otherToolDetail"
                  label={t(
                    'userSettings:subscription.cancel.reasons.whichToolDetail',
                  )}
                  component={InputComponent}
                  autoFocus
                  large
                />
              </div>
            )}
          </div>
        </SimpleModal>
      )}
    </Form>
  );
}
